import React from 'react';
import { Route, Redirect, useLocation } from "react-router-dom";

export const PractitionerRoute = ({ component: Component,
    layout: Layout,
    isAuth: isAuthenticated,
    userType,
    ...rest }) => {
    return (
        <Route
            {...rest}
            render={props => {
                if (isAuthenticated && userType === "practitioner") {
                    console.log("teset---->", rest, isAuthenticated, userType)
                    return (<Layout><Component {...props} /></Layout>)
                }
                else return <Redirect to={{ pathname: "/static/login" }} />

            }}
        />
    )
}

